import React from 'react'
import PropTypes from "prop-types";
import {useI18nContext} from "../i18n/I18nContext";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";

export default function MainContainer({children}) {
    const i18nContext = useI18nContext()
    const ariaLabel = getI18nTextWithContext(i18nContext, 'a11y.aria.main')

    return <main id="main-content" className="mt-3" aria-label={ariaLabel} tabIndex={-1}>
            <div className="container mb-5">
                { children }
            </div>
        </main>
}
MainContainer.propTypes = {
    children: PropTypes.node.isRequired
}